export default __webpack_public_path__ + "static/media/age_resume.f8f3d3b6.svg";